import { c as _c } from "react/compiler-runtime";
import { StyledUtilsProps } from '../../helpers/StyledUtils';
import { StyledSwitch } from './SwitchInput';
interface Props extends StyledUtilsProps {
  checked: boolean;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  show_label?: boolean;
  disabled?: boolean;
}
const Switch: React.FC<Props> = t0 => {
  const $ = _c(17);
  let checked;
  let onChange;
  let props;
  let show_label;
  if ($[0] !== t0) {
    ({
      onChange,
      checked,
      show_label,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = onChange;
    $[3] = props;
    $[4] = show_label;
  } else {
    checked = $[1];
    onChange = $[2];
    props = $[3];
    show_label = $[4];
  }
  const t1 = !!show_label;
  let t2;
  if ($[5] !== checked || $[6] !== show_label) {
    t2 = show_label && <span>{checked ? "On" : "Off"}</span>;
    $[5] = checked;
    $[6] = show_label;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== checked || $[9] !== onChange || $[10] !== props.disabled) {
    t3 = <input type="checkbox" checked={checked} disabled={props.disabled} onChange={onChange} />;
    $[8] = checked;
    $[9] = onChange;
    $[10] = props.disabled;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t4 = <StyledSwitch as="label" has_label={t1} {...props}>{t2}{t3}</StyledSwitch>;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
export default Switch;